import React, { useState, useContext } from 'react';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { GlobalStateContext } from './GlobalState';

const SearchInline = ({ inputText }) => {
  const { isLoggedInSpotify } = useContext(GlobalStateContext);
  const navigate = useNavigate();
  const [songs, setSongs] = useState([]);

  const handleLoadSongs = async () => {
    if (!inputText || inputText.trim() === '') {
      return; // Don't perform search if input is empty
    }
    
    try {
      const url = `/searchx?search_text=${inputText.trim()}${!isLoggedInSpotify ? '&public=true' : ''}`;
      const response = await fetch(url);
      if (response.status === 401) {
        window.location.href = '/';
        return;
      }
      const data = await response.json();
      setSongs(data);
      navigate('/builder/search', { state: { songs: data } });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    /*
    <Button variant="primary" onClick={handleLoadSongs}>
      {name || 'Search'}
    </Button>
    */
    <button className="btn btn-primary" type="button" onClick={handleLoadSongs}>
      <i className="bi bi-search"></i>
    </button>
 
  );
};

export default SearchInline;
